/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Entry/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Action from './Action/index'
import Author from './Author/index'
import CreatedAt from './CreatedAt/index'
import Profile from './Profile/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Entry({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Appointment/Actions/Unscheduled/More/Content/AppointmentHistory/Content/Main/Content/Entry"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="Entry.Horizontal"
  data-view-path={viewPath}
 style={{'--mb-1-4PFPn': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<Profile
  viewPath={`${viewPath}/Profile`}
/>
<div
  data-testid="Entry.Vertical"
  data-view-path={viewPath}
 style={{'--ml-2-4PFPn': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Entry.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<Author
  viewPath={`${viewPath}/Author`}
/>
<Action
  viewPath={`${viewPath}/Action`}
/>
</div>
<CreatedAt
  viewPath={`${viewPath}/CreatedAt`}
/>
</div>
</div>
{children}
</React.Fragment>)
}